import gql from "graphql-tag";
import { PRODUCT_THUMBNAIL, MOBILE_PRODUCT_THUMBNAIL } from "@components/ProductPage/ProductThumbnail/queries";

export const NEW_PRODUCT_LIST = gql`
  ${PRODUCT_THUMBNAIL}
  query newProducts(
    $first: Int
    $isMgs: Boolean
  ) {
    products(
      first: $first,
      newProducts: true,
      stockAvailability: IN_STOCK,
      isMgs: $isMgs
    ) {
      edges {
        node {
          ...productThumbnail
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const MOBILE_NEW_PRODUCT_LIST = gql`
  ${MOBILE_PRODUCT_THUMBNAIL}
  query mobileNewProducts(
    $first: Int
    $isMgs: Boolean
  ) {
    products(
      first: $first,
      newProducts: true,
      stockAvailability: IN_STOCK,
      isMgs: $isMgs
    ) {
      edges {
        node {
          ...mobileProductThumbnail
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
